import { Expose, Type } from '@nts/std/serialization';
import { ReportInfoDto } from "./report-info.dto";

export class MultiReportInfoDto {

    constructor() {
        this.reportInfoList = [];
    }

    @Expose()
    @Type(() => ReportInfoDto)
    reportInfoList: ReportInfoDto[];

}
